import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationDevicesComponent } from '../../components/location-devices/location-devices.component';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { RouteUtil } from 'src/app/general/util/route-util';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStatus } from '../../util/util';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { Util } from 'src/app/general/util/util';
import { NavigationService } from '../../services/navigation.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-location-devices-page',
  standalone: true,
  imports: [
    CommonModule,
    LocationDevicesComponent,
    PageComponent,
    LocationHeaderComponent,
    ActionComponent,
    TranslateModule
  ],
  templateUrl: './location-devices-page.component.html',
  styleUrls: ['./location-devices-page.component.css']
})
export class LocationDevicesPageComponent implements OnInit {

  locationId: string;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute,
      private navigationService: NavigationService) {
    this.locationId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.locationId = Util.safeString(pathParams.get('locationId'));
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }
}
